import React, { Component, useContext } from 'react'
import renderHTML from 'react-render-html'
import { PARTY_COLORS } from '../../constants/colors'
import DropdownComponent from '../dropdown/component'
import CombinedSearchComponent from '../combinedSearch/component'
import { isBrowser, isMobile } from 'react-device-detect'
import _ from 'lodash'
import { Search, Grid, Label } from 'semantic-ui-react'
import './styles.scss'

import { LocaleContext } from 'contexts/locale'

type Props = {
  data: string[]
  updateHandler: Function
  dropdownHandler: Function
  setFilterState: Function
  filterValue: string
  council: string
  locale: string[]
}

type State = {
  isLoading: boolean
  results: string[]
  value: string
  allMembersByParty: string[]
  filterableMembers: Record<string, any>
  locale: string[]
  globalLocale: string[]
  showFilters: boolean
  fixedSearch: boolean
  userSetFilter: boolean
}

const initialState = {
  isLoading: false,
  results: [],
  value: '',
  allMembersByParty: [],
  filterableMembers: {},
  locale: [],
  globalLocale: [],
  showFilters: true,
  fixedSearch: false,
  userSetFilter: false
}

const categoryRenderer = ({ name }) => {
  const locale = useContext(LocaleContext)
  const globalMessages = require('locales/' + locale + '.yml')

  return (
    <Label
      className='party-label'
      content={globalMessages.UI.Global.Parties[name]}
      style={{ background: PARTY_COLORS[name] }}
    />
  )
}

const resultRenderer = ({ Vorname, Nachname, Kanton }) => (
  <div>
    <p className='member-name'>
      <Label className='canton-label' content={Kanton} />
      {Vorname} {Nachname}
    </p>
  </div>
)

class ScrollToInput extends Component {
  componentDidMount() {
    // window.scrollTo(0,200);
    const searchEl = document.querySelector(
      '#' + this.props.council + '-search'
    )
    if (searchEl && isMobile) {
      setTimeout(() => {
        searchEl.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }, 0)
      return
    }
    const dropdownEl = document.querySelector(
      '#' + this.props.council + '-dropdown'
    )
    if (dropdownEl && isMobile) {
      setTimeout(() => {
        dropdownEl.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }, 0)
    }
  }

  render() {
    return <div style={{ display: 'none' }} />
  }
}

export class FilterComponent extends Component<Props, State> {
  state = initialState

  componentWillMount() {
    const locale = this.context
    const messages = require('./locales/' + locale + '.yml')
    const globalMessages = require('locales/' + locale + '.yml')
    this.setState({
      locale: messages,
      globalLocale: globalMessages
    })
  }

  componentDidMount() {
    const sortedByName = this.props.data.sort((a, b) => a.Nachname - b.Nachname)
    const allMembersByParty = _.groupBy(sortedByName, el => el.Partei)
    let membersObject = {}
    /* Add event listener for mobile search convenience */
    _.forEach(allMembersByParty, (val, key) => {
      membersObject = {
        ...membersObject,
        [key]: {
          name: key,
          results: val
        }
      }
    })
    this.setState({
      filterableMembers: membersObject
    })
  }

  getBirthday(date) {
    if (!date) {
      return '?'
    }
    const day = date.split('.')[0]
    const month = date.split('.')[1]
    const year = date.split('.')[2]

    const today = new Date()
    const birthDate = new Date(year + '-' + month + '-' + day)
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  handleDropdown = (val, additionalFilters) => {
    this.setState({
      userSetFilter: true
    })
    this.props.setFilterState(!val && !additionalFilters)
    this.props.dropdownHandler(val, additionalFilters)
  }

  handleResultSelect = (e, { result }) => {
    this.setState({ value: result.Vorname + ' ' + result.Nachname })
    this.props.updateHandler(null, result.Vorname, result.Nachname)
  }

  handleSearchChange = (e, { value }) => {
    this.setState({ isLoading: true, value })

    document
      .querySelector('#' + this.props.council + '-search input')
      .addEventListener('focus', e => this.setState({ fixedSearch: true }))
    document
      .querySelector('#' + this.props.council + '-search input')
      .addEventListener('blur', e => this.setState({ fixedSearch: false }))

    setTimeout(() => {
      if (this.state.value.length < 1) {
        this.props.updateHandler(-1)
        this.setState({ value: '', isLoading: false })
        return
      }

      const re = new RegExp(_.escapeRegExp(this.state.value), 'i')

      // The regex test() method will look in the stringified result object for matches
      const isMatch = result =>
        re.test(
          JSON.stringify(
            result.Nachname +
              ' ' +
              result.Vorname +
              ' ' +
              this.state.globalLocale.UI.Global.Parties[result.Partei] +
              ' ' +
              this.state.globalLocale.UI.Global.Cantons[result.Kanton] +
              ' ' +
              result.Geburtsdatum +
              ' ' +
              result['Wohnort ' + this.context] +
              ' ' +
              result.Kanton +
              ' ' +
              result['Beruf ' + this.context] +
              ' ' +
              result['Text ' + this.context] +
              ' ' +
              this.getBirthday(result.Geburtsdatum) +
              ' ' +
              this.state.globalLocale.UI.Global.Gender[result.Geschlecht]
          )
        )

      const filteredResults = _.reduce(
        this.state.filterableMembers,
        (memo, data, name) => {
          const results = _.filter(data.results, isMatch)
          if (results.length) memo[name] = { name, results }
          // eslint-disable-line no-param-reassign
          else {
            this.props.updateHandler(-1)
          } // eslint-disable-line no-param-reassign
          return memo
        },
        {}
      )

      this.setState({
        isLoading: false,
        results: filteredResults
      })
    }, 300)
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props || isBrowser) {
    }
    /*
    this.setState({
      value: ''
    })
    */
  }

  resetFilter() {
    this.setState({
      value: ''
    })
    this.props.updateHandler(-1)
  }

  render() {
    const {
      isLoading,
      value,
      results,
      locale,
      showFilters,
      globalLocale
    } = this.state

    return (
      <div className='ui text container' style={{ marginBottom: '1rem' }}>
        {this.props.council === 'nr' ? (
          <Grid centered colums={16}>
            <div
              className='ui tiny message'
              style={{ textAlign: 'left', margin: '1rem auto' }}
            >
              <p className='ui left aligned'>
                {renderHTML(globalLocale.Content.DividerText)}
              </p>
            </div>
          </Grid>
        ) : (
          <Grid centered colums={16}>
            <div
              className='ui tiny message'
              style={{
                textAlign: 'left',
                margin: '1rem auto',
                display: 'none'
              }}
            >
              <p className='ui left aligned'>
                {renderHTML(globalLocale.Content.SecondRoundText)}
              </p>
            </div>
          </Grid>
        )}
        <Grid centered colums={16}>
          <Grid.Column fluid width={16}>
            <div className='two ui buttons'>
              <button
                style={{
                  margin: '0 auto',
                  display: 'block'
                }}
                className={`ui select-button ${
                  showFilters ? 'active blue inverted' : 'basic'
                } icon button`}
                onClick={() =>
                  this.setState({ fixedSearch: false, showFilters: true })
                }
              >
                <i className='icon filter' /> {locale.ShowFilters}
              </button>
              <button
                style={{
                  margin: '0 auto',
                  display: 'block'
                }}
                className={`ui select-button ${isMobile ? 'mini' : ''} 
                ${!showFilters ? 'active blue inverted' : 'basic'} icon button`}
                onClick={() =>
                  this.setState({ fixedSearch: false, showFilters: false })
                }
              >
                <i className='icon search' /> {locale.ShowSearch}
              </button>
            </div>
          </Grid.Column>
        </Grid>

        {!showFilters && (
          <Grid
            centered
            columns={1}
            className={`${this.state.fixedSearch && isMobile ? '_fixed' : ''}`}
          >
            <Grid.Column width={16} id={`${this.props.council}-search`}>
              <div
                style={{
                  position: 'relative',
                  boxSizing: 'border-box'
                }}
              >
                <Search
                  ref={`${this.props.council}-search`}
                  onFocus={() => this.setState({ fixedSearch: true })}
                  onBlur={() => this.setState({ fixedSearch: false })}
                  placeholder={`${locale.TextFilter.PlaceHolder}`}
                  category
                  autoFocus={this.state.fixedSearch}
                  fluid
                  categoryRenderer={categoryRenderer}
                  resultRenderer={resultRenderer}
                  loading={isLoading}
                  onResultSelect={this.handleResultSelect}
                  onSearchChange={_.debounce(this.handleSearchChange, 500, {
                    leading: true
                  })}
                  results={results}
                  value={value}
                  {...this.props}
                />
              </div>
            </Grid.Column>
          </Grid>
        )}

        <Grid centered columns={1}>
          {this.state.value && (
            <Grid.Column width={16}>
              <button
                className='ui tiny red basic icon button'
                style={{
                  margin: '0 auto',
                  display: 'block'
                }}
                onClick={() => this.resetFilter()}
              >
                <i className='icon remove' />
                {locale.TextFilter.Delete}
              </button>
            </Grid.Column>
          )}
        </Grid>

        {showFilters && !value && (
          <Grid centered columns={1} className='dropdown-grid'>
            {/* OLD FILTER COMPONENT
            <Grid.Column
              width={16}
              className={this.state.fixedSearch && isMobile ? '_fixed' : ''}
              id={`${this.props.council}-dropdown`}
            >
              <DropdownComponent
                council={this.props.council}
                focusHandler={() => this.setState({ fixedSearch: true })}
                blurHandler={() => this.setState({ fixedSearch: false })}
                globalLocale={globalLocale}
                isFixed={this.state.fixedSearch}
                onHandleDropdown={this.handleDropdown}
                placeholder={locale.Dropdown.PlaceHolder}
                userSetFilter={this.state.userSetFilter}
              />
            </Grid.Column>
            */}
            <Grid.Column
              width={16}
              className={this.state.fixedSearch && isMobile ? '_fixed' : ''}
            >
              <CombinedSearchComponent
                data={this.props.data}
                council={this.props.council}
                focusHandler={() => this.setState({ fixedSearch: true })}
                blurHandler={() => this.setState({ fixedSearch: false })}
                globalLocale={globalLocale}
                isFixed={this.state.fixedSearch}
                onHandleDropdown={this.handleDropdown}
                placeholder={locale.Dropdown.PlaceHolder}
                userSetFilter={this.state.userSetFilter}
              />
            </Grid.Column>
          </Grid>
        )}

        {this.state.fixedSearch && (
          <ScrollToInput el='._fixed' council={this.props.council} />
        )}
      </div>
    )
  }
}

FilterComponent.contextType = LocaleContext
